import { render } from "./expire.vue?vue&type=template&id=3d1b00cc&ts=true"
import script from "./expire.vue?vue&type=script&lang=ts"
export * from "./expire.vue?vue&type=script&lang=ts"

import "./expire.vue?vue&type=style&index=0&id=3d1b00cc&lang=scss"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__